// eslint-disable-next-line import/no-anonymous-default-export
export default {
  heading: "'Poppins', Times New Roman, Times, serif",
  body: "'Poppins', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', Oxygen, Cantarell, sans-serif",
}
